const LocaleIcon = (props: any) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox='0 0 14 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M1 6.50016C1 9.62978 3.53705 12.1668 6.66667 12.1668C9.79628 12.1668 12.3333 9.62978 12.3333 6.50016M1 6.50016C1 3.37055 3.53705 0.833496 6.66667 0.833496C9.79628 0.833496 12.3333 3.37055 12.3333 6.50016M1 6.50016H12.3333M5.51299 1.50088C3.69344 4.53872 3.69344 8.46178 5.51299 11.4996C6.04564 12.3892 7.28784 12.3892 7.82049 11.4996C9.64004 8.46178 9.64004 4.53872 7.82049 1.50088C7.28721 0.611251 6.04564 0.611251 5.51299 1.50088Z'
        stroke='#344054'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default LocaleIcon;
